// services/SellerService.js
import axiosInstance from "./axiosConfig";

const API_URL = process.env.REACT_APP_API_URL;

// Crear un nuevo seller (requiere projectId y email)
export const createSeller = async ({ projectId, email, name, phone, role }) => {
  const response = await axiosInstance.post(`${API_URL}/seller`, {
    projectId,
    email,
    name,
    phone,
    role,
  });
  return response;
};

// Obtener un seller por ID
export const getSellerById = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/seller/${id}`);
  return response;
};

// Obtener todos los sellers de un proyecto
export const getSellersByProject = async (projectId) => {
  const response = await axiosInstance.get(`${API_URL}/sellers/${projectId}`);
  return response;
};


// ❌ Eliminar un seller por ID
export const deleteSeller = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/seller/${id}`);
  return response.data;
};


